export const MIN_QUERY_LEN = 3;
export const INSIGHTS_SECTION_ID = "insights";
export const HEADER_SEARCH_WIDTH = 450;
